import {
  patchRequest,
  handleThrowSubmissionError
} from '../../../utilities/requests';
import { setReferralCryptoWallets } from './reducer';

export const handleSubmit = async (values, dispatch) => {
  try {
    const url = '/referral_crypto_wallet';
    const response = await patchRequest(url, values);
    await dispatch(
      setReferralCryptoWallets(response.data.referral_crypto_wallet)
    );
  } catch (error) {
    handleThrowSubmissionError(error.response);
  }
};
